define('lib/view/ModalRegion',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    return Marionette.Region.extend({

        el: '#sb_dialog',

        constructor: function () {
            //$('#sb_dialog, .modal-backdrop').remove();
            var $dialogContainer = $('#sb_dialog');
            if ($dialogContainer.length === 0) {
                $dialogContainer = $('<div id="sb_dialog" class="modal fade" tabindex="-1" role="dialog"/>').appendTo(document.body);
            }

            Marionette.Region.prototype.constructor.apply(this, arguments);
            this._ensureElement();

            var instance = this;
            this.$el.on('hidden.bs.modal', function () {
                instance.empty();
                instance.triggerMethod('hide');

                instance.$el.off('hidden.bs.modal');
            });

            this.$el.on('show.bs.modal', function () {
                instance.$el.off('show.bs.modal');
                if (instance.$el.data('bs.modal').options) {
                    instance.$el.data('bs.modal').options.backdrop = instance.getOption('closeOnBackdropClick') ? true : 'static'
                } else if (instance.$el.data('bs.modal')._config) {
                    instance.$el.data('bs.modal')._config.backdrop = instance.getOption('closeOnBackdropClick') ? true : 'static'
                }
            });
        },

        onShow: function () {
            this.$el.modal('show');

            if( $('.modal-backdrop.fade.in').length == 0 ){
                var cover = '<div class="modal-backdrop fade in"></div>';
                $('body').append(cover);
            }
        },

        onClose: function () {
            this.$el.modal('hide');
            $('#sb_dialog, .modal-backdrop').remove();
            this._onCloseModal();
        },

        hide: function () {
            this.$el.modal('hide');
            $('#sb_dialog, .modal-backdrop').remove();
            this._onCloseModal();
        },

        _onCloseModal: function(){
            if(!$('.modal.in').length) {
                $('body').removeClass('modal-open');
            } else{
                $('body').addClass('modal-open').css('padding-right', 'unset');
            }
        }

    });

});
